import { ExclamationIcon } from '@mm/icons';
import { ReactComponent as FacebookIcon } from 'assets/facebook.svg';
import React from 'react';
import { Heading } from '@mm/components';
import {
  ButtonColor,
  PrimaryButton,
} from '../../buttons/PrimaryButton/PrimaryButton';
import {
  CloseModalProps,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../modal-helpers';
import styles from './Dec2020FbApiEuropeChangesModal.module.css';

interface Props extends CloseModalProps {
  onClose?: () => void;
}

const HELP_DOC_URL =
  'https://customers.ai/help/article/cg1qvuexfy-updated-messaging-policies-for-eu-pages-users';

export const Dec2020FbApiEuropeChangesModal = ({
  closeModal,
  onClose,
}: Props) => {
  const close = () => {
    onClose?.();
    closeModal();
  };
  return (
    <div className={styles.modal}>
      <ModalHeader
        closeOverride={close}
        className={styles.header}
        childrenContainerClassName={styles.headerChildren}
      >
        <ExclamationIcon className={styles.headerIcon} />
        <div>
          <Heading size={2} text="IMPORTANT Updates to FB Messaging Policies" />
        </div>
      </ModalHeader>

      <ModalBody className={styles.body}>
        <FacebookIcon className={styles.bodyIcon} />
        <div>
          <p>
            <strong>Effective Wednesday December 16, 2020</strong>, some
            Messenger features will no longer be available for{' '}
            <strong>
              businesses in Europe, and for people in Europe who connect with
              businesses globally.
            </strong>
          </p>
          <p>
            If you have a page based in an affected EU country or plan to
            connect with EU residents via Messenger please update your chatbot
            in anticipation of these changes.
          </p>
          <p>
            See this{' '}
            <a href={HELP_DOC_URL} target="_blank" rel="noopener noreferrer">
              helpdoc
            </a>{' '}
            for more information.
          </p>
        </div>
      </ModalBody>

      <ModalFooter className={styles.footer}>
        <PrimaryButton
          color={ButtonColor.secondaryBlue}
          className={styles.button}
          onClick={close}
        >
          Close
        </PrimaryButton>

        <PrimaryButton
          color={ButtonColor.blue}
          className={styles.button}
          onClick={() => {
            window.open(HELP_DOC_URL, '_blank');
            close();
          }}
        >
          Learn More
        </PrimaryButton>
      </ModalFooter>
    </div>
  );
};
